var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "file-chooser",
    },
    [
      _c(
        "button",
        {
          staticClass: "button",
          on: {
            click: _vm.openDialog,
          },
        },
        [_vm._v(_vm._s(_vm.buttonTitle))]
      ),
      _c("span", [_vm._v(_vm._s(_vm.selectedName))]),
      _vm._v(" "),
      _vm.showDialog
        ? _c(
            "file-chooser-dialog",
            _vm._b(
              {
                on: {
                  close: _vm.closeDialog,
                  selected: _vm.select,
                },
              },
              "file-chooser-dialog",
              _vm.$props,
              false
            )
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }